import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Outlet } from '@rocketlane/rocket-router';
import React, { Suspense, lazy } from 'react';
import { CreditNoteEssentialSettings } from 'components/organisms/credit-notes-settings/essential-setting';
import { AntdRlUISwitcherProvider } from 'contexts/antd-rlui-switcher';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { KnowledgeBaseFeatureWrapper } from './scarlet-wrapper';
const EmailSettingsPage = /*#__PURE__*/ lazy(()=>import('./email-intelligence/email-settings').then((m)=>({
            default: m.EmailSettingsPage
        })));
const NitroCreditConsumptionPage = /*#__PURE__*/ lazy(()=>import('./nitro-credit-consumption/page').then((m)=>({
            default: m.NitroCreditConsumptionPage
        })));
const BlacklistedDomainsPage = /*#__PURE__*/ lazy(()=>import('./email-intelligence/blacklisted-domains').then((m)=>({
            default: m.BlacklistedDomainsPage
        })));
const PostingPeriods = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/revenue-entries/revenue-settings').then((m)=>({
            default: m.PostingPeriods
        })));
const RevenueEssentials = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/revenue-entries/revenue-settings').then((m)=>({
            default: m.RevenueEssentials
        })));
const BudgetFieldsSettingsPage = /*#__PURE__*/ lazy(()=>import('./budget-fields/budget-fields').then((m)=>({
            default: m.BudgetFieldsSettingsPage
        })));
const ScimPage = /*#__PURE__*/ lazy(()=>import('./scim').then((m)=>({
            default: m.ScimPage
        })));
const ExpenseApprovalSettings = /*#__PURE__*/ lazy(()=>import('components/organisms/expense-settings/approval-workflow/approval-settings').then((m)=>({
            default: m.ExpenseApprovalSettings
        })));
const InvoiceApprovalSettings = /*#__PURE__*/ lazy(()=>import('components/organisms/invoice-settings/approval-workflow/approval-settings').then((m)=>({
            default: m.InvoiceApprovalSettings
        })));
const BillingScheduleTemplatesListPage = /*#__PURE__*/ lazy(()=>import('components/organisms/invoice-settings/billing-schedule/list').then((m)=>({
            default: m.BillingScheduleTemplatesListPage
        })));
const ExistingBillingScheduleTemplatePage = /*#__PURE__*/ lazy(()=>import('components/organisms/invoice-settings/billing-schedule/template-landing').then((m)=>({
            default: m.ExistingBillingScheduleTemplatePage
        })));
const NewBillingScheduleTemplatePage = /*#__PURE__*/ lazy(()=>import('components/organisms/invoice-settings/billing-schedule/template-landing').then((m)=>({
            default: m.NewBillingScheduleTemplatePage
        })));
const BillingScheduleProviderShell = /*#__PURE__*/ lazy(()=>import('./billing-schedule-provider-shell').then((m)=>({
            default: m.BillingScheduleProviderShell
        })));
const InvoicingCustomFields = /*#__PURE__*/ lazy(()=>import('components/organisms/invoice-settings/custom-fields/custom-fields').then((m)=>({
            default: m.InvoicingCustomFields
        })));
const InvoiceEssentialSettings = /*#__PURE__*/ lazy(()=>import('components/organisms/invoice-settings/essential-settings').then((m)=>({
            default: m.InvoiceEssentialSettings
        })));
const TaxSettings = /*#__PURE__*/ lazy(()=>import('components/organisms/invoices/taxes/settings').then((m)=>({
            default: m.TaxSettings
        })));
const TaxCodes = /*#__PURE__*/ lazy(()=>import('components/organisms/invoices/taxes/tax-codes').then((m)=>({
            default: m.TaxCodes
        })));
const AccountAddressSettings = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/address/address').then((m)=>({
            default: m.AccountAddressSettings
        })));
const AiFillsPage = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/ai-fills/ai-fills-page').then((m)=>({
            default: m.AiFillsPage
        })));
const MeetingIntelligenceMeetingSignalsPage = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/meeting-intelligence/meeting-signals').then((m)=>({
            default: m.MeetingIntelligenceMeetingSignalsPage
        })));
const MeetingIntelligenceSetupAndRecordingPage = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/meeting-intelligence/setup-and-recording').then((m)=>({
            default: m.MeetingIntelligenceSetupAndRecordingPage
        })));
const BillingSettings = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/billing').then((m)=>({
            default: m.BillingSettings
        })));
const CustomDomain = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/custom-domain').then((m)=>({
            default: m.CustomDomain
        })));
const CustomerNotificationSettingsPage = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/customer-portal-config/customer-notifications').then((m)=>({
            default: m.CustomerNotificationSettingsPage
        })));
const NotificationsConfigPage = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/customer-portal-config/customer-notifications').then((m)=>({
            default: m.NotificationsConfigPage
        })));
const ProjectTabsVisibility = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/customer-portal-config/project-tab-visibility').then((m)=>({
            default: m.ProjectTabsVisibility
        })));
const EmailConfiguration = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/email-configuration').then((m)=>({
            default: m.EmailConfiguration
        })));
const Financials = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/financials/financials').then((m)=>({
            default: m.Financials
        })));
const Integrations = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/integrations').then((m)=>({
            default: m.Integrations
        })));
const Workato = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/integrations/integrations-list').then((m)=>({
            default: m.Workato
        })));
const Zapier = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/integrations/integrations-list').then((m)=>({
            default: m.Zapier
        })));
const Jira = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/integrations/integrations-list/jira/jira').then((m)=>({
            default: m.Jira
        })));
const KeyeventsAndIntervalsSettings = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/key-events-and-intervals/settings').then((m)=>({
            default: m.KeyeventsAndIntervalsSettings
        })));
const NotificationSettingsPage = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/notifications').then((m)=>({
            default: m.NotificationSettingsPage
        })));
const ProfileSettingsPage = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/profile').then((m)=>({
            default: m.ProfileSettingsPage
        })));
const ResourceManagementSettings = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/resource-management').then((m)=>({
            default: m.ResourceManagementSettings
        })));
const SkillMatrixSettingsPage = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/skill-matrix/skill-matrix.page').then((m)=>({
            default: m.SkillMatrixSettingsPage
        })));
const TeamMemberSettingsPage = /*#__PURE__*/ lazy(()=>import('components/organisms/module-settings/team-members/team-members').then((m)=>({
            default: m.TeamMemberSettingsPage
        })));
const AdvancedSettingsPage = /*#__PURE__*/ lazy(()=>import('components/pages').then((m)=>({
            default: m.AdvancedSettingsPage
        })));
const ExpenseSettings = /*#__PURE__*/ lazy(()=>import('components/pages/expense-settings').then((m)=>({
            default: m.ExpenseSettings
        })));
const OutOfOffice = /*#__PURE__*/ lazy(()=>import('components/pages/out-of-office').then((m)=>({
            default: m.OutOfOffice
        })));
const PartnerDetail = /*#__PURE__*/ lazy(()=>import('components/pages/partner/detail').then((m)=>({
            default: m.PartnerDetail
        })));
const PartnerList = /*#__PURE__*/ lazy(()=>import('components/pages/partner/list').then((m)=>({
            default: m.PartnerList
        })));
const PartnerTeamMembers = /*#__PURE__*/ lazy(()=>import('components/pages/partner/team-members').then((m)=>({
            default: m.PartnerTeamMembers
        })));
const RocketlaneAPIPage = /*#__PURE__*/ lazy(()=>import('components/pages/rocketlane-api').then((m)=>({
            default: m.RocketlaneAPIPage
        })));
const TimesheetSettings = /*#__PURE__*/ lazy(()=>import('components/pages/timesheet-settings').then((m)=>({
            default: m.TimesheetSettings
        })));
const NotFound = /*#__PURE__*/ lazy(()=>import('routes/404').then((m)=>({
            default: m.NotFound
        })));
const CustomerPortalThemeById = /*#__PURE__*/ lazy(()=>import('routes/customer-portal/cpt-theme-by-id').then((m)=>({
            default: m.CustomerPortalThemeById
        })));
const CustomerPortalNotificationSettingsPage = /*#__PURE__*/ lazy(()=>import('routes/customer-portal/customer-portal-notification-settings-page').then((m)=>({
            default: m.CustomerPortalNotificationSettingsPage
        })));
const CustomerPortalThemesList = /*#__PURE__*/ lazy(()=>import('routes/customer-portal/customer-portal-themes-list').then((m)=>({
            default: m.CustomerPortalThemesList
        })));
const CustomerPortalSettings = /*#__PURE__*/ lazy(()=>import('routes/customer-portal/embed-settings-page').then((m)=>({
            default: m.CustomerPortalSettings
        })));
const CustomerPortalInviteSettingsPage = /*#__PURE__*/ lazy(()=>import('routes/customer-portal/invite-config-settings-page').then((m)=>({
            default: m.CustomerPortalInviteSettingsPage
        })));
const NewCustomerPortalTheme = /*#__PURE__*/ lazy(()=>import('routes/customer-portal/new-customer-portal-theme').then((m)=>({
            default: m.NewCustomerPortalTheme
        })));
const ArchivedProjectsPage = /*#__PURE__*/ lazy(()=>import('./archived-projects').then((m)=>({
            default: m.ArchivedProjectsPage
        })));
const CompanyFieldsSettingsPage = /*#__PURE__*/ lazy(()=>import('./company-fields').then((m)=>({
            default: m.CompanyFieldsSettingsPage
        })));
const CurrencySettings = /*#__PURE__*/ lazy(()=>import('./currency').then((m)=>({
            default: m.CurrencySettings
        })));
const CustomAppsPage = /*#__PURE__*/ lazy(()=>import('./custom-apps/custom-apps-page').then((m)=>({
            default: m.CustomAppsPage
        })));
const CustomerTeamMemberFieldsSettingsPage = /*#__PURE__*/ lazy(()=>import('./customer-team-member-fields/customer-team-member-fields').then((m)=>({
            default: m.CustomerTeamMemberFieldsSettingsPage
        })));
const ExpenseFieldsSettingsPage = /*#__PURE__*/ lazy(()=>import('./expense-fields/expense-fields').then((m)=>({
            default: m.ExpenseFieldsSettingsPage
        })));
const GlobalAutomationSettings = /*#__PURE__*/ lazy(()=>import('./global-automations').then((m)=>({
            default: m.GlobalAutomationSettings
        })));
const AutomationDetail = /*#__PURE__*/ lazy(()=>import('./global-automations/automation-detail').then((m)=>({
            default: m.AutomationDetail
        })));
const AutomationLogs = /*#__PURE__*/ lazy(()=>import('./global-automations/automation-logs').then((m)=>({
            default: m.AutomationLogs
        })));
const GroupsCreationPage = /*#__PURE__*/ lazy(()=>import('./groups').then((m)=>({
            default: m.GroupsCreationPage
        })));
const GroupDetail = /*#__PURE__*/ lazy(()=>import('./groups/GroupDetail').then((m)=>({
            default: m.GroupDetail
        })));
const HolidayCalendarSettingPage = /*#__PURE__*/ lazy(()=>import('./holiday-calendar/holiday-calendar-settings-page').then((m)=>({
            default: m.HolidayCalendarSettingPage
        })));
const HubspotIntegrationsLandingPage = /*#__PURE__*/ lazy(()=>import('./integrations/hubspot').then((m)=>({
            default: m.HubspotIntegrationsLandingPage
        })));
const SalesForceIntegrationsLandingPage = /*#__PURE__*/ lazy(()=>import('./integrations/salesforce/salesforce-page').then((m)=>({
            default: m.SalesForceIntegrationsLandingPage
        })));
const SlackLandingPage = /*#__PURE__*/ lazy(()=>import('./integrations/slack/slack-landing-page').then((m)=>({
            default: m.SlackLandingPage
        })));
const LanguageConfigurationsPage = /*#__PURE__*/ lazy(()=>import('./language-configurations/page').then((m)=>({
            default: m.LanguageConfigurationsPage
        })));
const OrganisationSettingPage = /*#__PURE__*/ lazy(()=>import('./organisation').then((m)=>({
            default: m.OrganisationSettingPage
        })));
const PermisionHomePage = /*#__PURE__*/ lazy(()=>import('./permissions').then((m)=>({
            default: m.PermisionHomePage
        })));
const PermissionCreationPage = /*#__PURE__*/ lazy(()=>import('./permissions/permission-creation-route').then((m)=>({
            default: m.PermissionCreationPageRoute
        })));
const ProjectFieldsV2SettingsPage = /*#__PURE__*/ lazy(()=>import('./project-fields-v2').then((m)=>({
            default: m.ProjectFieldsV2SettingsPage
        })));
const RateCardsPage = /*#__PURE__*/ lazy(()=>import('./rate-cards').then((m)=>({
            default: m.RateCardsPage
        })));
const RolesSettingsPage = /*#__PURE__*/ lazy(()=>import('./roles').then((m)=>({
            default: m.RolesSettingsPage
        })));
const SecurityPage = /*#__PURE__*/ lazy(()=>import('./security').then((m)=>({
            default: m.SecurityPage
        })));
const SettingsPageLayout = /*#__PURE__*/ lazy(()=>import('./settings-page-layout').then((m)=>({
            default: m.SettingsPageLayout
        })));
const SkillFieldsSettingsPage = /*#__PURE__*/ lazy(()=>import('./skill-fields/skill-fields').then((m)=>({
            default: m.SkillFieldsSettingsPage
        })));
const SprintPlanningSettings = /*#__PURE__*/ lazy(()=>import('./sprint-planning').then((m)=>({
            default: m.SprintPlanningSettings
        })));
const SprintFields = /*#__PURE__*/ lazy(()=>import('./sprint-planning/sprint-fields').then((m)=>({
            default: m.SprintFields
        })));
const TaskFieldsSettingsPage = /*#__PURE__*/ lazy(()=>import('./task-fields').then((m)=>({
            default: m.TaskFieldsSettingsPage
        })));
const TeamMemberFieldsSettingsPage = /*#__PURE__*/ lazy(()=>import('./team-member-fields').then((m)=>({
            default: m.TeamMemberFieldsSettingsPage
        })));
const TimeEntryFieldsSettingsPage = /*#__PURE__*/ lazy(()=>import('./time-entry-fields/time-entry-fields').then((m)=>({
            default: m.TimeEntryFieldsSettingsPage
        })));
const EditWebhookPage = /*#__PURE__*/ lazy(()=>import('./webhook/edit-webhook-page').then((m)=>({
            default: m.EditWebhookPage
        })));
const NewWebhookPage = /*#__PURE__*/ lazy(()=>import('./webhook/new-webhook-page').then((m)=>({
            default: m.NewWebhookPage
        })));
const WebhookPage = /*#__PURE__*/ lazy(()=>import('./webhook/webhook').then((m)=>({
            default: m.WebhookPage
        })));
const EpicFields = /*#__PURE__*/ lazy(()=>import('./sprint-planning/epic-fields').then((m)=>({
            default: m.EpicFields
        })));
const VaultPage = /*#__PURE__*/ lazy(()=>import('./connection-store').then((m)=>({
            default: m.VaultPage
        })));
export const VaultPageWithFeatureFlag = ()=>{
    const [isWorkforceAgentEnabled] = useAccountFeature(AccountFeature.WorkforceAgent);
    const [isAutopilotAgentEnabled] = useAccountFeature(AccountFeature.AutopilotAgent);
    if (!isWorkforceAgentEnabled && !isAutopilotAgentEnabled) {
        return /*#__PURE__*/ _jsx(NotFound, {});
    }
    return /*#__PURE__*/ _jsx(VaultPage, {});
};
const KnowledgeBasePage = /*#__PURE__*/ React.lazy(()=>import('signals/KnowledgeBasePage'));
const KnowledgeBaseFolderPage = /*#__PURE__*/ React.lazy(()=>import('signals/KnowledgeBaseFolderPage'));
const AllocationFieldsSettingsPage = /*#__PURE__*/ lazy(()=>import('./allocation-fields/allocation-fields').then((m)=>({
            default: m.AllocationFieldsSettingsPage
        })));
export const settingsRoutes = {
    path: ROUTE_PATHS.SETTINGS,
    element: /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Outlet, {})
    }),
    children: [
        {
            path: ROUTE_PATHS.SETTINGS_PROFILE,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(ProfileSettingsPage, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_NITRO_CREDIT_CONSUMPTION,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(NitroCreditConsumptionPage, {})
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_NOTIFICATIONS,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(NotificationSettingsPage, {})
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_CUSTOMER_PORTAL_NOTIFICATIONS,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_CUSTOMER_PORTAL:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(CustomerPortalNotificationSettingsPage, {})
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_CUSTOMER_PORTAL_OLD,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_CUSTOMER_PORTAL:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(CustomerNotificationSettingsPage, {})
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_CUSTOMER_PORTAL_INVITE_CONFIGURATION,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(CustomerPortalInviteSettingsPage, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_EMBED_CUSTOMER_PORTAL,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(CustomerPortalSettings, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_CUSTOMER_PORTAL_THEMES,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(CustomerPortalThemesList, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_CUSTOMER_PORTAL_THEMES}/${ROUTE_PATHS.NEW}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(NewCustomerPortalTheme, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_CUSTOMER_PORTAL_THEMES}/${ROUTE_PATHS.SETTINGS_CUSTOMER_PORTAL_THEME_ID}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(CustomerPortalThemeById, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_ORGANISATION,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_ORGANISATION:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(OrganisationSettingPage, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_HOLIDAY_CALENDAR,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_HOLIDAY_CALENDAR:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(HolidayCalendarSettingPage, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_OUT_OF_OFFICE,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_OUT_OF_OFFICE:WRITE",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(OutOfOffice, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_BILLING,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "BILLING:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    checkIfUserHasAccessToBilling: true,
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(BillingSettings, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_TEAM_MEMBERS,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_TEAM_MEMBER:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(TeamMemberSettingsPage, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_CUSTOMER_TEAM_MEMBER_FIELDS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_CUSTOMER_TEAM_MEMBER_FIELD:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    checkIfCustomerPortalIsEnabled: true,
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(CustomerTeamMemberFieldsSettingsPage, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_SKILL_MATRIX}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_SKILL_MATRIX:READ",
                children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                    children: /*#__PURE__*/ _jsx(SkillMatrixSettingsPage, {})
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_GROUPS}/${ROUTE_PATHS.MATCH_ALL}`,
            caseSensitive: true,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_TEAM_MEMBER:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    checkIfCurrentUserIsAccountAdmin: true,
                    checkIfRbacIsEnabled: true,
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(GroupsCreationPage, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_GROUPS}/${ROUTE_PATHS.SETTINGS_GROUP_DETAILS}/${ROUTE_PATHS.MATCH_ALL}`,
            caseSensitive: true,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_TEAM_MEMBER:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    checkIfCurrentUserIsAccountAdmin: true,
                    checkIfRbacIsEnabled: true,
                    children: /*#__PURE__*/ _jsx(GroupDetail, {})
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_ROLES}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_ROLE:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(RolesSettingsPage, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_PERMISSIONS,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    checkIfCurrentUserIsAccountAdmin: true,
                    checkIfRbacIsEnabled: true,
                    children: /*#__PURE__*/ _jsx(PermisionHomePage, {})
                })
            }),
            caseSensitive: true
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_PERMISSIONS}/${ROUTE_PATHS.SETTINGS_NEW_PERMISSION_SET}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(PermissionCreationPage, {})
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_PERMISSIONS}/${ROUTE_PATHS.SETTINGS_EDIT_PERMISSION_SET}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(PermissionCreationPage, {})
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_CUSTOMER_PORTAL_CONFIG,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_CUSTOMER_PORTAL:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(CustomerNotificationSettingsPage, {})
                })
            }),
            children: [
                {
                    path: ROUTE_PATHS.SETTINGS_CUSTOMER_PORTAL_PROJECT_TABS,
                    element: /*#__PURE__*/ _jsx(ProjectTabsVisibility, {})
                },
                {
                    path: ROUTE_PATHS.SETTINGS_CUSTOMER_PORTAL_CLIENT_NOTIFICATIONS,
                    element: /*#__PURE__*/ _jsx(NotificationsConfigPage, {
                        customerConfig: true
                    })
                }
            ]
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_PARTNERS}/*`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_PARTNER:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(PartnerList, {})
                    })
                })
            }),
            caseSensitive: true,
            children: []
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_PARTNERS}/${ROUTE_PATHS.ID}/${ROUTE_PATHS.VIEW}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_PARTNER:READ",
                children: /*#__PURE__*/ _jsx(PartnerDetail, {})
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_PARTNERS}/${ROUTE_PATHS.ID}/${ROUTE_PATHS.TEAM_MEMBERS}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_PARTNER:READ",
                children: /*#__PURE__*/ _jsx(PartnerTeamMembers, {})
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_INTEGRATIONS,
            caseSensitive: true,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_INTEGRATION:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(Integrations, {})
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_INTEGRATIONS}/${ROUTE_PATHS.SETTINGS_JIRA_INTEGRATION}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_INTEGRATION:READ",
                children: /*#__PURE__*/ _jsx(Jira, {})
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_INTEGRATIONS}/${ROUTE_PATHS.SETTINGS_ZAPIER_INTEGRATION}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_INTEGRATION:READ",
                children: /*#__PURE__*/ _jsx(Zapier, {})
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_INTEGRATIONS}/${ROUTE_PATHS.SETTINGS_WORKATO_INTEGRATION}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_INTEGRATION:READ",
                children: /*#__PURE__*/ _jsx(Workato, {})
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_INTEGRATIONS}/${ROUTE_PATHS.SETTINGS_SALESFORCE_INTEGRATION}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_INTEGRATION:READ",
                children: /*#__PURE__*/ _jsx(SalesForceIntegrationsLandingPage, {})
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_INTEGRATIONS}/${ROUTE_PATHS.SETTINGS_SLACK_INTEGRATION}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_INTEGRATION:READ",
                children: /*#__PURE__*/ _jsx(SlackLandingPage, {})
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_INTEGRATIONS}/${ROUTE_PATHS.SETTINGS_HUBSPOT_INTEGRATION}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_INTEGRATION:READ",
                children: /*#__PURE__*/ _jsx(HubspotIntegrationsLandingPage, {})
            })
        },
        {
            path: `${ROUTE_PATHS.TAXES}/${ROUTE_PATHS.SETTINGS}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_TAX:CREATE",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(TaxSettings, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.TAXES}/${ROUTE_PATHS.TAXES_CODES}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "TAXCODE_AND_TAXCOMPONENT:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(TaxCodes, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_TIMESHEETS,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_TIME_SHEET:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(TimesheetSettings, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_EXPENSE_MANAGEMENT}/${ROUTE_PATHS.ESSENTIALS}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(ExpenseSettings, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_EXPENSE_MANAGEMENT}/${ROUTE_PATHS.APPROVALS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_EXPENSE_APPROVAL_WORKFLOW:CREATE",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(ExpenseApprovalSettings, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_RESOURCE_MANAGEMENT,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_RESOURCE_MANAGEMENT:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(ResourceManagementSettings, {})
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_FINANCIALS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_FINANCIAL:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(Financials, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_REVENUE}/${ROUTE_PATHS.REVENUE_ESSENTIALS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_REVENUE_ENTRY:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(RevenueEssentials, {})
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_REVENUE}/${ROUTE_PATHS.POSTING_PERIODS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_REVENUE_ENTRY:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(PostingPeriods, {})
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_CURRENCY,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_CURRENCY:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(CurrencySettings, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_RATE_CARDS,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "RATE_CARD:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    checkIfUserHasAccessToViewRateCards: true,
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(RateCardsPage, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_SPRINT_PLANNING,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(SprintPlanningSettings, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_SPRINT_FIELDS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(SprintFields, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_EPIC_FIELDS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(EpicFields, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_PROJECT_FIELDS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_PROJECT_FIELD:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(ProjectFieldsV2SettingsPage, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_TASK_FIELDS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_TASK_FIELD:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(TaskFieldsSettingsPage, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_TEAM_MEMBER_FIELDS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_TEAM_MEMBER_FIELD:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(TeamMemberFieldsSettingsPage, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_BUDGET_FIELDS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_PROJECT_FINANCIALS_BUDGET_FIELDS:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(BudgetFieldsSettingsPage, {})
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_TIME_ENTRY_FIELDS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_TIME_ENTRY_FIELD:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(TimeEntryFieldsSettingsPage, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_ALLOCATION_FIELDS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_ALLOCATION_FIELD:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AllocationFieldsSettingsPage, {})
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_EXPENSE_FIELDS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_EXPENSE_FIELD:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(ExpenseFieldsSettingsPage, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_COMPANY_FIELDS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_CUSTOMER_COMPANY_FIELD:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(CompanyFieldsSettingsPage, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_SKILL_FIELDS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_SKILL_FIELD:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    checkIfUserHasAccessToSkillMatrix: true,
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(SkillFieldsSettingsPage, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_CUSTOM_DOMAIN,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_CUSTOM_DOMAIN:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(CustomDomain, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_EMAIL_CONFIGURATION,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_EMAIL_CONFIGURATION:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(EmailConfiguration, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_SECURITY,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_SECURITY:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(SecurityPage, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_SCIM,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_SECURITY:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(ScimPage, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_VAULT,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_VAULT:WRITE",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(VaultPageWithFeatureFlag, {})
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_API,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_ADVANCED:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(RocketlaneAPIPage, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_WEBHOOK,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "PUBLIC_WEBHOOK:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(WebhookPage, {})
                    })
                })
            }),
            children: [
                {
                    path: ROUTE_PATHS.NEW,
                    element: /*#__PURE__*/ _jsx(NewWebhookPage, {})
                },
                {
                    path: `${ROUTE_PATHS.WEBHOOK_ID}/${ROUTE_PATHS.EDIT}`,
                    element: /*#__PURE__*/ _jsx(EditWebhookPage, {})
                }
            ]
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_KEY_EVENT_AND_INTERVALS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_KEY_EVENTS_AND_INTERVALS:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(KeyeventsAndIntervalsSettings, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_CUSTOM_APPS}/`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(CustomAppsPage, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_AUTOMATIONS,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_AUTOMATION:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(GlobalAutomationSettings, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.AUTOMATION_LOGS}/${ROUTE_PATHS.AUTOMATION_TYPE}/${ROUTE_PATHS.AUTOMATION_ID}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_AUTOMATION:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AutomationDetail, {})
                })
            })
        },
        {
            path: `${ROUTE_PATHS.AUTOMATION_LOGS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_AUTOMATION:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AutomationLogs, {})
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_ADVANCED,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_ADVANCED:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AdvancedSettingsPage, {})
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_ARCHIVED_PROJECTS,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(ArchivedProjectsPage, {})
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_AI_FILLS,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_AI_FILLS:WRITE",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(AiFillsPage, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_MEETING_INTELLIGENCE_SETUP,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_AI_FILLS:WRITE",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(MeetingIntelligenceSetupAndRecordingPage, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_MEETING_INTELLIGENCE_MEETING_SIGNALS,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_AI_FILLS:WRITE",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(MeetingIntelligenceMeetingSignalsPage, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_EMAIL_INTELLIGENCE}/${ROUTE_PATHS.SETTINGS_EMAIL_SETTINGS}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "EMAIL_INTELLIGENCE_SETTINGS:WRITE",
                children: /*#__PURE__*/ _jsx(EmailSettingsPage, {})
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_EMAIL_INTELLIGENCE}/${ROUTE_PATHS.SETTINGS_BLACKLISTED_DOMAINS}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "EMAIL_INTELLIGENCE_SETTINGS:WRITE",
                children: /*#__PURE__*/ _jsx(BlacklistedDomainsPage, {})
            })
        },
        {
            path: `${ROUTE_PATHS.SETTINGS_KNOWLEDGE_BASE}/${ROUTE_PATHS.KNOWLEDGE_BASE_FOLDER}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(KnowledgeBaseFeatureWrapper, {
                    children: /*#__PURE__*/ _jsx(KnowledgeBaseFolderPage, {})
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_KNOWLEDGE_BASE,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(KnowledgeBaseFeatureWrapper, {
                    children: /*#__PURE__*/ _jsx(KnowledgeBasePage, {})
                })
            })
        },
        {
            path: ROUTE_PATHS.SETTINGS_LANGUAGE_CONFIGURATIONS,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                    children: /*#__PURE__*/ _jsx(LanguageConfigurationsPage, {})
                })
            })
        },
        // invoice/essentials
        {
            path: `${ROUTE_PATHS.INVOICE}/${ROUTE_PATHS.ESSENTIALS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_INVOICE:CREATE",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(InvoiceEssentialSettings, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.INVOICE}/${ROUTE_PATHS.BILLING_SCHEDULE_TEMPLATE}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "BILLING_EVENT_TEMPLATE:WRITE",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(BillingScheduleTemplatesListPage, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.INVOICE}/${ROUTE_PATHS.BILLING_SCHEDULE_TEMPLATE}/${ROUTE_PATHS.NEW}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "BILLING_EVENT_TEMPLATE:WRITE",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(Suspense, {
                        fallback: null,
                        children: /*#__PURE__*/ _jsx(BillingScheduleProviderShell, {
                            children: /*#__PURE__*/ _jsx(NewBillingScheduleTemplatePage, {})
                        })
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.INVOICE}/${ROUTE_PATHS.BILLING_SCHEDULE_TEMPLATE}/${ROUTE_PATHS.TEMPLATE_ID}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "BILLING_EVENT_TEMPLATE:WRITE",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(Suspense, {
                        fallback: null,
                        children: /*#__PURE__*/ _jsx(BillingScheduleProviderShell, {
                            children: /*#__PURE__*/ _jsx(ExistingBillingScheduleTemplatePage, {})
                        })
                    })
                })
            })
        },
        {
            // invoice/approvals
            path: `${ROUTE_PATHS.INVOICE}/${ROUTE_PATHS.APPROVALS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_INVOICE_APPROVAL_WORKFLOW:CREATE",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(InvoiceApprovalSettings, {})
                    })
                })
            })
        },
        {
            // path: RoutePaths.invoiceCustomFieldsSettings,
            // invoice/custom-fields
            path: `${ROUTE_PATHS.SETTINGS_INVOICE_CREDIT_NOTES_CUSTOM_FIELDS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_INVOICE_FIELD:READ",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(InvoicingCustomFields, {})
                    })
                })
            })
        },
        {
            path: `${ROUTE_PATHS.CREDIT_NOTES}/${ROUTE_PATHS.ESSENTIALS}/${ROUTE_PATHS.MATCH_ALL}`,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_CREDIT_NOTE:WRITE",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(CreditNoteEssentialSettings, {})
                    })
                })
            })
        },
        // {
        //   // credit-notes/approvals
        //   path: `${ROUTE_PATHS.CREDIT_NOTES}/${ROUTE_PATHS.APPROVALS}/${ROUTE_PATHS.MATCH_ALL}`,
        //   element: (
        //     // <SecureRoute rule="SETTINGS_CREDIT_NOTE_APPROVAL_WORKFLOW:CREATE">
        //     <SettingsPageLayout>
        //       <CreditNoteApprovalSettings />
        //     </SettingsPageLayout>
        //     // </SecureRoute>
        //   ),
        // },
        {
            // path: RoutePaths.addressSettings,
            // address
            path: ROUTE_PATHS.ADDRESS,
            element: /*#__PURE__*/ _jsx(SecureRoute, {
                rule: "SETTINGS_ACCOUNT_ADDRESS:CREATE",
                children: /*#__PURE__*/ _jsx(SettingsPageLayout, {
                    children: /*#__PURE__*/ _jsx(AntdRlUISwitcherProvider, {
                        children: /*#__PURE__*/ _jsx(AccountAddressSettings, {})
                    })
                })
            })
        },
        {
            path: ROUTE_PATHS.MATCH_ALL,
            element: /*#__PURE__*/ _jsx(NotFound, {})
        }
    ]
};
